// Modules
import { Link, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { useRef } from 'react';

// CSS
import '_Asset/css/Admin/Include/adSideMenu.css'

// Component
import { adMenuList } from 'Admin/Component/AdMenuList'
import { useState } from 'react';


const ChildMenu = ({child, depth = 1}) => {

  const location = useLocation();
  const path = location.pathname;
  const useRefs = useRef(null)

  const hasChildren = child.children && child.children.length;

  return (
    <li>
      <Link to={child.url} ref={useRefs} className={`${path.includes(child.url) || path.includes(child.url2)  ? 'active' : ''} ${child.children ? 'childTrue' : ''}`}>
        {child.ico && <i className={child.ico}></i>}
        <span>{child.title}</span>

        {hasChildren && <i className="icofont-rounded-right"></i>}
      </Link>
      { 
        (path.includes(child.url)) && hasChildren && 
        <ul className={`depth_${depth}`}>
          {child.children?.map((children, i) =>
            <ChildMenu key={i} child={children} depth={depth + 1} />
          )}
        </ul>
      }
    </li>
  )
}

const MenuComp = ({list, userRoles}) => {

  return (
    <div className="adMenuBox">
      <h2>{list.title}</h2>

      <ul>
        {list.children?.map((child, i) =>
          (child?.roles <= userRoles || child?.roles === undefined) && <ChildMenu key={i} child={child} />
        )}
      </ul>
    </div>
  )
}

const AdSideMenu = () => {

  const [adSideState, setAdSideState] = useState(true);
  const userRoles = useSelector(state => state.authorityAcc.roles_num);

  return (
    <div className={`adSideMenu ${adSideState ? 'active' : ''}`}>
      <button type="button" className="icofont-rounded-left foldBtn" onClick={() => setAdSideState(!adSideState)}></button>
      
      <div className='inner'>
        {adMenuList.map((list, i) => 
          (list?.roles <= userRoles || list?.roles === undefined) && <MenuComp key={i} list={list} userRoles={userRoles} /> 
        )}
      </div>
    </div>
  )
}

export default AdSideMenu;